import React, { useCallback, useState } from 'react';
import { PromocodeViewModel } from '@common/model/billing/promocode';
import { SerializedError } from '@reduxjs/toolkit';
import { ActivatePromoCodeFormProps, PromocodeSwitchForm } from 'src/entities/promo';
import { useActivatePromocode } from '../model';

export interface ClientActivatePromocodeProps {
  size?: 'small' | 'normal';
}
export const ClientActivatePromocodeForm: React.FC<ClientActivatePromocodeProps> = ({ size }) => {
  const activatePromocode = useActivatePromocode();
  const [promocode, setPromocode] = useState<PromocodeViewModel>();
  const [error, setError] = useState<SerializedError>();
  const onValid = useCallback<NonNullable<ActivatePromoCodeFormProps['onValid']>>(
    async (values) => {
      const res = await activatePromocode(values);
      res.map(setPromocode);
      res.mapError(setError);
    },
    [activatePromocode],
  );

  return <PromocodeSwitchForm activateFormProps={{ onValid, error, size }} promocode={promocode} />;
};
